import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import LoadingComponent from '../../LoadingComponent';
import OverviewTableRow from './OverviewTableRow';
import TableError from '../../table/TableError';
import css from '../../../styles/front/overviewtable';

class OverviewTable extends Component {
    static propTypes = {
        // Props
        columns: PropTypes.array.isRequired,
        error: PropTypes.bool.isRequired,
        ranking: PropTypes.string.isRequired,
        isFetching: PropTypes.bool.isRequired,
        height: PropTypes.number.isRequired,
        ready: PropTypes.bool.isRequired,
        sources: PropTypes.string.isRequired,
        symbols: PropTypes.array.isRequired,
        reloading: PropTypes.bool.isRequired,
        reload: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        const t = this.props.t;

        this._getHeadings = () => {
            switch (this.props.ranking) {
            case '-TURNOVER':
                return [t('name'), t('turnover_short'), t('percentChange')];
            case '-TURNOVER_TOTAL':
            case '-TURNOVER_MAX':
                return [t('name'), t('size'), t('percentChange')];
            case 'CHANGE_PCT':
            case '-CHANGE_PCT':
            default:
                return [t('name'), t('last'), t('percentChange')];
            }
        };

        this._getColumnByIndex = index => {
            const headings = this._getHeadings();

            if (index < headings.length) {
                return headings[index];
            }

            return '';
        };

        this._compare = (a, b) => {
            if (a === b) {
                return 0;
            }

            return (a > b) ? -1 : 1;
        };

        this._sortSymbols = symbols => {
            switch (this.props.ranking) {
            case '-CHANGE_PCT':
                return symbols.sort((a, b) => (
                    this._compare(a.values.CHANGE_PCT, b.values.CHANGE_PCT))
                );
            case 'CHANGE_PCT':
                return symbols.sort((a, b) => (
                    this._compare(b.values.CHANGE_PCT, a.values.CHANGE_PCT))
                );
            case '-TURNOVER':
                return symbols.sort((a, b) => (
                    this._compare(a.values.TURNOVER, b.values.TURNOVER))
                );
            case '-TURNOVER_MAX':
                return symbols.sort((a, b) => (
                    this._compare(a.values.TURNOVER_MAX, b.values.TURNOVER_MAX))
                );
            case '-TURNOVER_TOTAL':
                return symbols.sort((a, b) => (
                    this._compare(a.values.TURNOVER_TOTAL, b.values.TURNOVER_TOTAL))
                );
            default:
                return symbols;
            }
        };
    }

    renderHeader() {
        return (
            <div className={css.tableHeader}>
                <div className={css.tableHead}>
                    {this._getColumnByIndex(0)}
                </div>
                <div className={[css.tableHead, css.alignRight].join(' ')}>
                    {this._getColumnByIndex(1)}
                </div>
                <div className={[css.tableHead, css.alignRight].join(' ')}>
                    {this._getColumnByIndex(2)}
                </div>
            </div>
        );
    }

    renderBody() {
        if (this.props.symbols.length === 0) {
            return (
                <div className={css.noData}>
                    <p>{this.props.t('noData')}</p>
                </div>
            );
        }

        return this._sortSymbols(this.props.symbols).map(symbol => (
            <OverviewTableRow
                key={symbol.key}
                ranking={this.props.ranking}
                {...symbol.values}
            />
        ));
    }

    render() {
        const { error, isFetching, height, ready, reloading, t } = this.props;

        if (error) {
            return (
                <TableError
                    text={t('tryAgain')}
                    height={height}
                    reloading={reloading}
                    onClick={this.props.reload}
                />
            );
        }

        if (isFetching || reloading || !ready) {
            return <LoadingComponent height={height} />;
        }

        return (
            <div data-columns={3} className={[css.table, css.padded].join(' ')}>
                {this.renderHeader()}
                {this.renderBody()}
            </div>
        );
    }
}

export default translate('common')(OverviewTable);



/** WEBPACK FOOTER **
 ** /src/shared/components/front/overview/OverviewTable.js
 **/